import {Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {TooltipTranslationService} from '~shared/translations';
import {StorageService, TixxSelectSubmissionService} from '~core/services';
import {ButtonsTranslations} from '~shared/components/buttons/buttons-translations.service';
import {Club, Customer, InvoiceOrderStatus, TixxSelectSubmission} from '~core/models';

/**
 * Component that displays information on customer invoices and tickets
 */
@UntilDestroy()
@Component({
  selector: 'app-tixx-select-view',
  templateUrl: './tixx-select-view.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class TixxSelectViewComponent implements OnInit, OnDestroy {
  @Input() public customer: Customer;
  public selectedClub: Club;
  public selectedSubmission: TixxSelectSubmission;
  public invoiceOrderStatus: InvoiceOrderStatus;
  public primaryRequestOpened: boolean = true;
  public secondaryRequestOpened: boolean = true;
  public additionalOptionsOpened: boolean = true;

  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];

  constructor(
    public customerService: CustomerOverViewService,
    public buttonsTranslations: ButtonsTranslations,
    public tooltipTranslations: TooltipTranslationService,
    public storageService: StorageService,
    public submissionService: TixxSelectSubmissionService,
    public tablesTranslations: TablesTranslations,
    @Inject(LOCALE_ID) public locale: any
  ) {
    this.storageService.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
    this.submissionService.castSelectedSubmission.pipe(untilDestroyed(this))
      .subscribe(submission => this.selectedSubmission = submission);
  }

  public ngOnInit(): void {
    this.columns.push(this.tablesTranslations.i18nPriceCategory, this.tablesTranslations.i18nPriceReduction,
      this.tablesTranslations.i18nAmount);
    this.keys.push([
      'priceCategoryAssignedReduction.priceCategory.name',
      'priceCategoryAssignedReduction.reduction.name',
      'fullAmount'
    ]);
  }

  public ngOnDestroy(): void {
  }

  /**
   * Toggles the accordion for each section
   */
  public toggleSection(section: string): void {
    switch (section) {
      case 'primaryRequest':
        this.primaryRequestOpened = !this.primaryRequestOpened;
        break;
      case 'secondaryRequest':
        this.secondaryRequestOpened = !this.secondaryRequestOpened;
        break;
      case 'additionalOptions':
        this.additionalOptionsOpened = !this.additionalOptionsOpened;
        break;
      default:
    }
  }

}
